import type {
  IGranularity,
  IUploadStatus,
  IUploadStatusUIData,
} from '@gp/pages/Pipeline/ProjectDetails/Milestone/types';

import ICON_UPLOAD_SUCCESS from '@gp/assets/svg/upload-file-state/success.svg';
import ICON_UPLOAD_FAIL from '@gp/assets/svg/upload-file-state/fail.svg';
import ICON_UPLOAD_WAIT from '@gp/assets/svg/upload-file-state/wait.svg';

// 新增、编辑Milestone表单中 is_launch开关表单控件的新特性强提醒key
export const MILESTONE_IS_LAUNCH_SWITCHER_NEW_FEATURE_TIPS_KEY = 'dbg-pipeline-milestone-is-launch-switcher-tips';
// 新增、编辑Milestone表单中 is_launch开关表单控件的新特性强提醒内容
export const MILESTONE_IS_LAUNCH_SWITCHER_NEW_FEATURE_TIPS_CONTENT =
  'Turn on this button to display this Milestone in the Launch Calendar on the Overview page.';

// 财务金额小数位数限制
export const FINANCIALS_AMOUNT_DECIMALS = 6;

// milestone financials模块 5个固定的milestones
export const KEY_MILESTONES = [
  'Concept',
  'End of Pre-Production (Vertical Slice)',
  'Feature Complete (Alpha)',
  'Content Complete (Beta)',
  'Early Access',
];
// export const KEY_MILESTONES = ['Concept', 'Vertical Slice', 'Alpha', 'Beta', 'Early Access'];

export const MILESTONE_CONSTANT_TEXTS = {
  OFFICIAL_GATE_REVIEW_SWITCHER: 'Display this milestone in the GR Calendar',
  LAUNCH_SWITCHER: 'Display Milestone in the Launch Calendar',
};

// 时间粒度与时间粒度unit（moment操作方法用到的时间粒度unit）
export const GRANULARITY_UNITS: Record<IGranularity, 'days' | 'weeks' | 'months'> = {
  daily: 'days',
  weekly: 'weeks',
  monthly: 'months',
};

export const UPLOAD_STATUS_ICONS: Record<IUploadStatus, IUploadStatusUIData> = {
  1: {
    teaIcon: 'success',
    icon: ICON_UPLOAD_SUCCESS,
    text: 'Upload successful',
  },
  2: {
    teaIcon: 'error',
    icon: ICON_UPLOAD_FAIL,
    text: 'Upload failed',
  },
  3: {
    teaIcon: '',
    icon: ICON_UPLOAD_WAIT,
    text: 'To be uploaded',
  },
  4: {
    teaIcon: 'loading',
    icon: '',
    text: 'Upload [progress]...',
  },
};
